import { createContext, type ReactNode, useContext } from 'react';

const OverlayPortalContext = createContext<HTMLElement | null>(null);

/**
 * Lets nested poppers (sheet cell dropdowns) portal onto a surface that
 * stacks above the page and moves with it — a drawer paper, not document.body.
 */
export function OverlayPortalProvider({
  container,
  children,
}: {
  container: HTMLElement | null;
  children: ReactNode;
}) {
  return (
    <OverlayPortalContext.Provider value={container}>
      {children}
    </OverlayPortalContext.Provider>
  );
}

export function useOverlayPortalContainer(): HTMLElement | null {
  return useContext(OverlayPortalContext);
}
